module.exports = __webpack_public_path__ + "static/media/scale.e3852f14.png";